import { Action } from '@ngrx/store';
import { StateUpdateFns } from 'ngrx-forms';
import {
  NgrxFormExtensionModel,
  HasNgrxForm
} from '@app/common/ngrx-forms-extensions';
import {
  TicketRatingFormValue,
  TicketRatingFormState
} from './ticket-rating.model';

const formKey = '[Rating] Form';

const formModel = new NgrxFormExtensionModel<TicketRatingFormValue>(formKey);

export const getFormKey = (id: string) => formModel.getKey(id);

export const formState = (id: string) => (
  defaultValues: Partial<TicketRatingFormValue> = {},
  updateFns: StateUpdateFns<TicketRatingFormValue> = {}
) => ({
  [getFormKey(id)]: formModel.createFormState(
    id,
    {
      speed: undefined,
      expertise: undefined,
      communication: undefined,
      message: undefined
    },
    defaultValues,
    updateFns
  )
});

export const applyFormReducer = <S extends HasNgrxForm>(
  state: S,
  action: Action,
  id: string,
  defaultSettings?: StateUpdateFns<TicketRatingFormValue>
) => formModel.reduceAction(state, action, id, defaultSettings);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const markAsSubmitted = (id: string, state: any) => formModel.markAsSubmitted(id, state);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const markAsUnsubmitted = (id: string, state: any) => formModel.markAsUnsubmitted(id, state);
export const formSelector = (id: string) => formModel.selectState<TicketRatingFormState>(id);
export const formValueSelector = (id: string) => formModel.selectValue(id);
export const updateGroupAction = (
  id: string,
  value: Partial<TicketRatingFormValue>
) => formModel.updateGroupValue(id, value);
